import { Component, Emit, Mixins, Prop, Ref } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import GridHeader from '@/components/GridHeader.vue'
import { LaboratoryStatisticalAnalysisSidebarDateInput } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { BModal } from 'bootstrap-vue'
import { StatisticalAnalysisDossiers, StatisticalAnalysisDossiersDatasourceResponsesDetailTypes, StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDossiersExternalInfo, StatisticalAnalysisEnumsAndKeys, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { initialStatisticAnalysisExternalViewDetailTableState, StatisticAnalysisExternalViewDetailTableState } from '@/modules/statistical-analysis-module/components/statistical-analysis-external-views/statistical-analysis-external-views-detail-table/statistical-analysis-external-views-detail-table.model'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { statisticalAnalysisHandlerFactory } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-handler.factory'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import commonCaseServices from '@/api/resources/common/commonCaseServices'
import { registryCasePrintService } from '@/modules/printModule/services/registry-case-print-service'
import { get, has, isArray } from 'lodash'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { AgGridCallbackEvent } from '@/shared/models/ag-grid.model'
import BaseCrudInfiniteServerSideComponent from '@/shared/resources/base-crud-infinite-side.component'
import { AxiosResponse } from 'axios'
import { CommonExportType } from '@/api/resources/common/shared/models/common.models'
import { Formatter } from '@/filters/formatter'

@Component({
    components: {
        VtGrid,
        GridDisplayOptions,
        GridHeader
    }
})
export default class StatisticAnalysisExternalViewDetailTable extends Mixins<BaseCrudInfiniteServerSideComponent<StatisticalAnalysisDossiersDatasourceResponsesDetailTypes>>(BaseCrudInfiniteServerSideComponent) {
    @Ref() readonly statisticalAnalysisExternalViewsDetailTableModal!: BModal
    @Prop() readonly row!: StatisticalAnalysisDossiersDatasourceResponsesTypes
    @Prop() readonly filters!: StatisticalAnalysisViewDetailTableFilters
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams
    stateExternalList!: StatisticAnalysisExternalViewDetailTableState
    instanceDatasource!: StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisDossiersDatasourceResponsesDetailTypes> | null
    @Emit()
    hideModal(): boolean {
        return false
    }

    constructor() {
        super()
        this.stateExternalList = initialStatisticAnalysisExternalViewDetailTableState()
    }

    get gridOptionsTable(): GridOptions {
        return {
            ...this.gridOptions,
            defaultColDef: {
                resizable: true,
                suppressMenu: true
            }
        }
    }

    get getDossier(): string {
        switch (this.viewDetailParams.dossier) {
        case StatisticalAnalysisDossiers.GENERAL:
            return StatisticalAnalysisEnumsAndKeys.GENERAL_STATISTICS.getText()
        case StatisticalAnalysisDossiers.ACTIVITY:
            return StatisticalAnalysisEnumsAndKeys.ACTIVITY_STATISTICS.getText()
        case StatisticalAnalysisDossiers.INCIDENTS:
            return StatisticalAnalysisEnumsAndKeys.INCIDENTS_STATISTICS.getText()
        case StatisticalAnalysisDossiers.DELAYS_AND_RESPONSE_TIMES:
            return StatisticalAnalysisEnumsAndKeys.DELAYS_AND_RESPONSE_STATISTICS.getText()
        case StatisticalAnalysisDossiers.SAMPLE_TAGS:
            return StatisticalAnalysisEnumsAndKeys.SAMPLE_TAGS_STATISTICS.getText()
        default:
            return ''
        }
    }

    get laboratoriesSelected(): LaboratoryStatisticalAnalysisSidebarDateInput[] {
        return this.filters.externalFiltering.sidebarFilters?.laboratories as LaboratoryStatisticalAnalysisSidebarDateInput[]
    }

    get gridTitle(): string {
        const sidebar: StatisticalAnalysisDossiersExternalInfo = this.filters.externalFiltering.sidebarFilters as StatisticalAnalysisDossiersExternalInfo
        if (sidebar.trackingGeneralSelected) {
            if (has(sidebar, 'trackingDetailSelected')) {
                const trackingDetailSelected: StatisticalInfoPaginatorTrackingItems = get(sidebar, 'trackingDetailSelected')
                return `${this.$tc(sidebar?.trackingGeneralSelected?.label)} - ${this.$tc('statisticalAnalysis.dossiers.generalStatistics.detailFor')} ${this.$tc(trackingDetailSelected?.label)}`
            } else {
                return `${this.$tc(sidebar?.trackingGeneralSelected?.label)}`
            }
        } else {
            return Formatter.capitalize(`${this.$tc('statisticalAnalysis.dossiers.generalStatistics.detailFor')} ${this.$tc(this.getDossier)}`)
        }
    }

    get typeCase(): string {
        if (isArray(this.filters.externalFiltering.sidebarFilters?.typeSearch)) {
            const texts = this.filters.externalFiltering.sidebarFilters?.typeSearch.map((item: StatisticalAnalysisSidebarItemCombo) => this.$tc(item.text, 2))
            return (texts as string[])?.join(', ')
        } else {
            return this.$tc(this.filters.externalFiltering.sidebarFilters?.typeSearch?.text as string, 2)
        }
    }

    get startDate(): Date {
        return this.filters.externalFiltering.sidebarFilters?.startDate as Date
    }

    get endDate(): Date {
        return this.filters.externalFiltering.sidebarFilters?.endDate as Date
    }

    get totalElements(): string {
        if (this.state.totalElements) {
            return Formatter.number(this.state.totalElements)
        }
        return '-'
    }

    mounted(): void {
        this.deselectAll()
        this.instanceDatasource = statisticalAnalysisHandlerFactory.getDatasourceDetailList(this.viewDetailParams.dossier, this.filters, this.row)
        this.state.datasource.service = this.instanceDatasource
        this.state.columnsDef = this.instanceDatasource?.getGridColumns()
        this.statisticalAnalysisExternalViewsDetailTableModal.show()
    }

    onChangedMode(mode: any): void {
        this.changedMode(mode)
    }

    onChangedPageSize(size: number): void {
        this.changedPageSize(size)
    }

    onHide(): void {
        this.state.totalElements = null
        this.instanceDatasource!.setTotalElements(null)
        this.hideModal()
    }

    onEndCallback(_event: AgGridCallbackEvent) {
        this.state.totalElements = this.instanceDatasource!.getTotalElements()
    }

    exportReport(exportType: CommonExportType): Promise<AxiosResponse<Blob>> | null {
        const columns = this.getColumnsToExport()
        if (columns) {
            const instanceToExport =
                statisticalAnalysisHandlerFactory.getTableExporting(
                    this.viewDetailParams.dossier,
                    this.filters,
                    columns,
                    this.state.selectedRows
                )
            if (instanceToExport) {
                return instanceToExport.exportExternal(this.row, exportType)
            }
        }
        return null
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            const selection = this.state.gridApi?.getSelectedRows()!
            const isMultipleSelection = selection?.length > 1
            return this._checkAllowedDossierAPAReport(this.viewDetailParams.dossier) ? [
                {
                    name: this.$tc('global.pathologicalReport'),
                    action: () => this._downloadAPA(params?.node?.data),
                    cssClasses: isMultipleSelection ? ['not-show'] : ['']
                }
            ] : []
        }
    }

    private _checkAllowedDossierAPAReport(dossier: StatisticalAnalysisDossiers): boolean {
        const allowedDossiersAPAReport = [
            StatisticalAnalysisDossiers.GENERAL,
            StatisticalAnalysisDossiers.ACTIVITY,
            StatisticalAnalysisDossiers.DELAYS_AND_RESPONSE_TIMES,
            StatisticalAnalysisDossiers.SAMPLE_TAGS
        ]
        return allowedDossiersAPAReport.includes(dossier)
    }

    private async _downloadAPA(row: StatisticalAnalysisDossiersDatasourceResponsesDetailTypes): Promise<void> {
        const [labId, caseId] = (this.state.datasource.service as StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisDossiersDatasourceResponsesDetailTypes>).getLabAndCaseId(row)
        if (caseId) {
            let includeAssociated = false
            if (await this._hasAssociatedCases(labId, caseId)) {
                includeAssociated = await this.$_showConfirmationModal(this.$t('global.modal.case.viewAssociatedCasesConfirmation') as string)
            }
            this.$_updateLoading(true)
            const blob = await this.$_toCallSecure(registryCasePrintService.downloadCaseAPReportPdf(labId, caseId, includeAssociated))
            if (blob) {
                this.$_openFile({ blob })
            }
            this.$_updateLoading(false)
        }
    }

    private async _hasAssociatedCases(labId:number, caseId:number):Promise<boolean> {
        const response = await this.$_toCallSecure(commonCaseServices.getAssociatedCases(labId, caseId))
        return !!response?.length
    }
}
